import _ from 'lodash';
import {
  WIDGET_GET,
  WIDGET_ERROR,
  WIDGET_UPDATE
} from '../constants/actionTypes';
import { getHomeWidgets, postWidgets } from '../utils/apiWidget';

const loadWidgets = widgetList => ({ type: WIDGET_GET, widgetList });
const errorLoadWidgets = err => ({ type: WIDGET_ERROR, err });
const updateWidgets = widgetList => ({ type: WIDGET_UPDATE, widgetList });

export const widgetGet = idUser => dispatch => {
  getHomeWidgets(idUser)
    .then(widgetList => {
      const widgetListWithLinks = widgetList.map(item => {
        const newItem = { ...item };
        switch (item.type) {
          case 'menuofday':
            newItem.link = '/menu/semanal';
            break;
          case 'resumen':
            newItem.link = '/resumen_prensa';
            break;
          case 'digitalaudiences':
            newItem.link = '/audiencias_digitales';
            break;
          case 'rrssaudiencia':
            newItem.link = '/audiencia_rrss';
            break;
          case 'strategy':
            newItem.link = '/strategy';
            break;
          case 'audiencesradio':
            newItem.link = '/audiencia_radio';
            break;
          case 'audiences':
          case 'ranking':
            newItem.link = '/audiencias';
            break;
          case 'md3':
            newItem.link = null;
            break;
          case 'plata':
            newItem.link = null;
            break;
          case 'player':
            newItem.link = '/video-event';
            break;
          case 'player2':
            newItem.link = '/video-webinar';
            break;
          case 'editAtresmedia':
            newItem.link = '/video-edit-atresmedia';
            break;
          case 'pressrelease':
          default:
            newItem.link = null;
            break;
        }

        return newItem;
      });

      // const widgetListWithoutShorcuts = _.remove(
      // widgetListWithLinks,
      // item => item.type !== 'shortcut'
      // );

      const widgetListWithLinksRemoved = _.remove(
        widgetListWithLinks,
        item =>
          item.type !== 'pressrelease' ||
          item.type !== 'player3' ||
          item.type !== 'player4'
      );

      return dispatch(loadWidgets(widgetListWithLinksRemoved));
    })
    .catch(err => dispatch(errorLoadWidgets(err)));
};

export const moveWidget = (position, type) => (dispatch, getState) => {
  if (position === 1 && type === 'widgetList/UP') {
    return;
  }
  dispatch({ type, position });
  const initState = getState().widget.widgetList;
  const initStateNoLinks = initState.map(item => {
    const newItem = { ...item };
    delete newItem.link;
    return newItem;
  });

  postWidgets(initStateNoLinks).catch(() => dispatch(updateWidgets(initState)));
};
